<div>
   <div class="row" >
        <div class="col-md-12">
            <div class="card-box">
                <h4>Personal Details</h4>
                <div v-if="!loading">
                    <p>
                        First Name: {{personalDetails.firstName}}
                    </p>
                    <p>
                        Last Name: {{personalDetails.lastName}}
                    </p>
                    <p>
                        Email Address: {{personalDetails.emailAddress}}
                    </p>
                    <!--                <p>-->
                    <!--                    Date of Birth: {{personalDetails.dateOfBirth}}-->
                    <!--                </p>-->
                </div>
                
                <p v-if="loading">Loading...</p>
            </div>

            <div class="card-box">
                <h4>Company Details</h4>
                <div v-if="!loading">
                    <p>
                        Customer Code: {{companyDetails.customerCode}}
                    </p>
                    <p>
                        Business Name: {{companyDetails.businessName}}
                    </p>
                    <p>
                        Trading Name: {{companyDetails.tradingName}}
                    </p>
                    <p>
                        Holding Company: {{companyDetails.holdingCompany}}
                    </p>
                    <p>
                        Registration Number: {{companyDetails.registrationNumber}}
                    </p>
                    <p>
                        Telephone Number: {{companyDetails.telephoneNumber}}
                    </p>
                    <p>
                        Sales Reps: {{companyDetails.salesRep}}
                    </p>
                    <p>
                        Tax Number: {{companyDetails.taxNumber}}
                    </p>
                </div>
                <p v-if="loading">Loading...</p>
            </div>
        </div>
   </div>
</div>
